export const appNameText = "Substitute Teachers Ireland"
export const appName = 'teachers';
export let userCookieName = 'userId'
export let roleCookieName = 'pkrole'
export const host = "localhost"
export const TEST = true
export const port = "8092"
export const protocol = "http"
export const baseurl = protocol+"://"+host+":"+port+"/"+appName
export const devDomain = "localhost"
export const devHome = "http://localhost:3000"

export const prodappName = 'subteachers';
export const prodhost = "subteachers-01.hapnotic.com"
export const prodport = "443"
export const prodprotocol = "https"
export const prodbaseurl = prodprotocol+"://"+prodhost+":"+prodport+"/"+prodappName
export const prodDomain = "subteachers.hapnotic.com"
export const prodHome = "https://"+prodDomain
export const prodFacebook = "https://www.facebook.com/hapnotic"
export const prodLinkedin = "https://www.linkedin.com/hapnotic"
export const prodSupportEmail = "support@subteachers.hapnotic.com"
export const prodSubject = "Support/Info Request for subteachers.hapnotic.com"
export const prodSupportPhone = "0877828053"

if(process.env.NODE_ENV === "development") {
  roleCookieName = roleCookieName+"_"+devDomain
}
else if(process.env.NODE_ENV === "production") {
  roleCookieName = roleCookieName+"_"+prodDomain
}

if(process.env.NODE_ENV === "development") {
  userCookieName = userCookieName+"_"+devDomain
}
else if(process.env.NODE_ENV === "production") {
  userCookieName = userCookieName+"_"+prodDomain
}

export const envBaseURL = () => {
  if(process.env.NODE_ENV === "development") {
    return baseurl
  }
  else if(process.env.NODE_ENV === "production") {
    return prodbaseurl
  }
}

export const homeURL = () => {
  if(process.env.NODE_ENV === "development") {
    return devHome
  }
  else if(process.env.NODE_ENV === "production") {
    return prodHome
  }
}
